import { FulfillmentGroupPickStatus } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { Order } from "@redotech/redo-model/order";
import type { MerchantAppReturn } from "@redotech/redo-model/return";
import {
  getEmailScope,
  type SupportTicketCollectionFilter,
} from "./support-ticket-collection-scope";

export type OrderWithPickStatus = Order & {
  pickStatuses: FulfillmentGroupPickStatus[];
};

export interface SupportTicketRelatedRecordsApi {
  getOrdersByEmail(
    email: string,
    options?: { limit?: number },
  ): Promise<OrderWithPickStatus[]>;
  getReturnsByEmail(
    email: string,
    options?: { limit?: number },
  ): Promise<MerchantAppReturn[]>;
}

export function getEmailFilterValue(
  filters: readonly SupportTicketCollectionFilter[],
  fieldName: string,
  validateEmail: boolean,
): string | null {
  return getEmailScope(filters, fieldName, validateEmail);
}
